var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon / minus"),React.createElement("g",{"id":"icon-/-minus","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group-7-Copy-2"},[React.createElement("rect",{"id":"Rectangle-Copy","fill":"#FFFFFF","x":"0","y":"0","width":"44","height":"44","rx":"22","key":0}),React.createElement("polygon",{"id":"↓-copy","className":"colorable","fill":"#24242C","transform":"translate(22.500000, 22.500000) scale(1, -1) rotate(-90.000000) translate(-22.500000, -22.500000) ","points":"22.464 30 23.5 30 24 30 24 15 21.024 15.0291892 21.024 26.5491892 21 30","key":1})]))]);
}

Minus.defaultProps = {"width":"44px","height":"44px","viewBox":"0 0 44 44","version":"1.1"};

module.exports = Minus;

Minus.default = Minus;
